import { render, staticRenderFns } from "./DropdownToggle.vue?vue&type=template&id=f11799aa&scoped=true"
import script from "./DropdownToggle.vue?vue&type=script&lang=js"
export * from "./DropdownToggle.vue?vue&type=script&lang=js"
import style0 from "./DropdownToggle.vue?vue&type=style&index=0&id=f11799aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11799aa",
  null
  
)

export default component.exports